<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="user.firstName +' '+ user.lastName" />
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >
          <button class="btn-icon-primary mr-1" @click="clickOnResetPassword">
            <mail-icon size="18"/> Changer le mot de passe
          </button>
        </show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm" v-if="user">

        <b-row class="mb-4">
          <b-col>
            <div class="bold-text main-color">
              Nom
            </div>
            <div class="mt-2">
              {{ user.lastName }}
            </div>
          </b-col>
          <b-col>
            <div class="bold-text main-color">
              Prénom
            </div>
            <div class="mt-2">
              {{ user.firstName }}
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col>
            <div class="bold-text main-color">
              Email
            </div>
            <div class="mt-2">
              <b-link :href="'mailto:'+user.username">{{user.username}}</b-link>
            </div>
          </b-col>
          <b-col>
            <div class="bold-text main-color">
              Numéro de téléphone
            </div>
            <div class="mt-2"  v-if="user.phone">
              <b-link :href="'tel:'+user.phone">{{user.phone}}</b-link>
            </div>
            <div v-else>
              -
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col>
            <div class="bold-text main-color">
              Téléphone conjoint(e)
            </div>
            <div class="mt-2"  v-if="user.secondPhone">
              <b-link :href="'tel:'+user.secondPhone">{{user.secondPhone}}</b-link>
            </div>
            <div v-else>
              -
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col>
            <div class="bold-text main-color">
              Animaux
            </div>
            <ul v-if="user.animals.length > 0" class="mt-2">
              <li class="mb-1" v-for="animal in user.animals">
                <b-link :to="{name: 'AnimalShow', params: {animalId: animal.id }}">{{animal.name}}</b-link>
                ({{animal.species}}) -
                <template v-if="animal.isHospitalized">hospitalisé</template>
                <template v-else>non hospitalisé</template>
              </li>
            </ul>
            <div v-else>
              Aucun animal
            </div>
          </b-col>
        </b-row>


      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <user-delete-modal v-if="ui.selectedUser" :selectedUser="ui.selectedUser" @didDeleteUser="didDeleteUser()"></user-delete-modal>
    <!-- Modal Reset Password -->
    <reset-password-modal v-if="ui.selectedUser" :selectedUser="ui.selectedUser" @didSendResetPassword="didSendResetPassword()"></reset-password-modal>

  </div>
</template>

<script>

    import api from '../../services/api';
    import BackArrow from "../../components/BackArrow";
    import ShowActions from "../../components/ShowActions";
    import UserDeleteModal from "./UserDeleteModal";
    import ResetPasswordModal from "./ResetPasswordModal";

    export default {

        name: 'UserShow',

        components: {
            BackArrow,
            ShowActions,
            UserDeleteModal,
            ResetPasswordModal
        },

        data() {
            return {
                userId: this.$route.params.userId,
                user: null,
                ui: {
                    selectedUser: null
                }
            }
        },

        created () {
            this.fetchData()
        },

        methods: {

            fetchData() {
                this.fetchUser()
            },

            fetchUser() {
                api
                    .get(`/user/${this.userId}`)
                    .then(response => {
                        this.user = response.data
                    })
            },

            setTotalCount(totalCount) {
                this.totalCount = totalCount
            },

            clickOnResetPassword(){
                this.ui.selectedUser = this.user
                this.$bvModal.show('reset-password-modal')
            },

            didSendResetPassword(){
                this.ui.selectedUser = null
            },

            clickOnEditBtn() {
                this.$router.push({
                    name: 'UserEdit',
                    params: {
                        userId: this.user.id
                    }
                })
            },

            clickOnDeleteBtn() {
                this.ui.selectedUser = this.user
                this.$bvModal.show('user-delete-modal')
            },

            didDeleteUser() {
                this.ui.selectedUser = null;
                this.$router.push({
                    name: 'UserIndex'
                }, () => {
                    this.$nextTick(() => {
                        this.successToast(`Compte utilisateur \"${this.user.firstName +" "+this.user.lastName}\" supprimé`)
                    })
                })
            },

            successToast(message) {
                this.$bvToast.toast(message, {
                    autoHideDelay: 20000,
                    toaster: 'b-toaster-bottom-right',
                    noCloseButton: true
                })
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserShow.vue